import { configureStore } from "@reduxjs/toolkit";
import ProfileReducer from "src/store/profile/profileSlice";
import NotificationsReducer from "src/store/notifications/notificationsSlice";
import EventsReducer from "src/store/events/eventsSlice";
import BetReducer from "src/store/bet/betSlice";

export const store = configureStore({
  reducer: {
    profile: ProfileReducer,
    notifications: NotificationsReducer,
    events: EventsReducer,
    bet: BetReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
